import {Component, OnInit, Inject} from '@angular/core';
import {FormGroup, FormControl, FormGroupDirective, NgForm, Validators, FormBuilder} from '@angular/forms';
import {AnnuityLotService} from 'src/app/services/annuity-lot.service';
import {AnnuityPriceService} from 'src/app/services/annuity-price.service';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatTableDataSource } from '@angular/material/table';
import {SubcategoryService} from 'src/app/services/subcategory.service';
import {CategoryPrice} from 'src/app/models/category-price';
import {SnackBarIconService} from 'src/app/shared/snack-bar-icon/snack-bar-icon.service';
import {AnnuityCatPriceService} from 'src/app/services/annuity-cat-price.service';

export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-annuity-cat-price-dialog',
  templateUrl: './annuity-cat-price-dialog.component.html',
  styleUrls: [ './annuity-cat-price-dialog.component.scss' ],
})
export class AnnuityCatPriceDialogComponent implements OnInit {

  public matcher = new FormErrorStateMatcher();

  public priceForm: FormGroup;
  public entityForm: FormGroup;

  public isPartner: boolean;
  public currentCategoryPrice: CategoryPrice;
  public arraySubCategories: any[] = []

  public subCategorySelected: any = {}
  public subCategorySelected_id: any;

  public selectedSubCategoriesDataSource: MatTableDataSource<any>;
  public displayedCategoryPricesColumns: string[] = [ 'icon', 'name', 'delete' ];

  public isEdit: boolean;

  constructor (
    private fb: FormBuilder,
    public _annuityLotService: AnnuityLotService,
    public _annuityPriceService: AnnuityPriceService,
    public _annuityCatPriceService: AnnuityCatPriceService,
    public _subcategoryService: SubcategoryService,
    private snackBar: SnackBarIconService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

  }

  ngOnInit () {

    this.isPartner = this.data.isPartner;
    this.currentCategoryPrice = this.data.categoryPrice

    if (this.currentCategoryPrice.id) {
      this.isEdit = true;
    } else {
      this.isEdit = false;
    }

    this._annuityPriceService.currentProductLot = this.data.lot;

    this.priceForm = this.createCatPriceForm();
    this.entityForm = this.createForm();

    this.loadSubCategories()

    this.setFormValues(this.currentCategoryPrice, this.entityForm)

  }

  loadSubCategories () {
    this._subcategoryService.selectAnnuityCategories()
      .subscribe((result) => {
        result.forEach((item) => {

          let cat = {
            'id': item.payload.doc.id,
            'name': item.payload.doc.data().name,
            'annuity': item.payload.doc.data().annuity
          }

          this.arraySubCategories.push(cat)
        })

        //  console.log("----------------------------")
        //  console.log(JSON.stringify(this.arraySubCategories))

      })

  }

  createCatPriceForm () {
    let form: FormGroup = this.fb.group({
      id: new FormControl(''),
      lot_id: new FormControl(''),
      lot_name: new FormControl(''),
      category_id: new FormControl(''),
      category_name: new FormControl(''),
      value: new FormControl('', [ Validators.required ]),
      value_pix: new FormControl('', [ Validators.required ])
    });

    return form
  }

  selectCategory (event) {
    //  console.log("selectCategory: " + event)
    this.subCategorySelected_id = event

    this.subCategorySelected = this.arraySubCategories.find((e) => {
      return e.id == this.subCategorySelected_id
    })

  }

  addSubCategory () {
    this.currentCategoryPrice.categories.push(this.subCategorySelected)
    this.selectedSubCategoriesDataSource = new MatTableDataSource(this.currentCategoryPrice.categories)
  }

  removeSubCategory (element) {
    const id = element.id
    this.currentCategoryPrice.categories = this.currentCategoryPrice.categories.filter((e) => {
      return e.id != id
    })
    this.selectedSubCategoriesDataSource = new MatTableDataSource(this.currentCategoryPrice.categories)
  }

  insert () {

    //console.log("his.data.product: " + JSON.stringify(this.data.product))

    this.entityForm.controls.lot_id.setValue(this.data.lot.id);
    this.entityForm.controls.product_id.setValue(this.data.product.id);
    this.entityForm.controls.partner.setValue(true);

    if (this.entityForm.valid) {

      let entity: CategoryPrice = this.createEntity(this.entityForm.value);
      //console.log("insert entity: " + JSON.stringify(entity))
      this._annuityCatPriceService.insert(entity)
        .then((result) => {
          // console.log("result: " + JSON.stringify(result))
          this.snackBar.openSnackBar("Sucesso!", '', 'success');
        })
        .catch((error) => {
          console.log("error: " + JSON.stringify(error))
          this.snackBar.openSnackBar("Erro!", '', 'error');
        })

    }


  }

  update () {

    if (this.entityForm.valid) {
      let entity: CategoryPrice = this.createEntity(this.entityForm.value);
      // console.log("entity: " + JSON.stringify(entity))

      this._annuityCatPriceService.update(entity)
        .then((result) => {
          // console.log("result: " + JSON.stringify(result))
          this.snackBar.openSnackBar("Sucesso!", '', 'success');
        })
        .catch((error) => {
          console.log("error: " + JSON.stringify(error))
          this.snackBar.openSnackBar("Erro!", '', 'error');
        })

    }

  }

  createEntity (data: any): CategoryPrice {

    let entity = new CategoryPrice();

    entity.id = data.id;
    entity.name = data.name;
    entity.foreigners_only = false; // 
    entity.lot_id = data.lot_id;
    entity.product_id = data.product_id;
    entity.requires_doc = false; //
    entity.list_doc = ""; // 
    entity.show_on_site = false; // 
    entity.value = Number(data.value);
    entity.value_pix = Number(data.value_pix);
    entity.value_defaulting = 0; // 
    entity.partner = true; //
    entity.categories = this.currentCategoryPrice.categories;

    return entity;
  }


  createForm () {
    let form: FormGroup = this.fb.group({
      id: new FormControl(''),
      name: new FormControl('', [ Validators.required ]),
      // requires_doc: new FormControl(''),
      // list_doc: new FormControl(''),
      // show_on_site: new FormControl(''),
      value: new FormControl(''),
      // value_defaulting: new FormControl(''),
      value_pix: new FormControl(''),
      lot_id: new FormControl(''),
      product_id: new FormControl(''),
      partner: new FormControl(true)
    });
    return form
  }

  setFormValues (data, form) {

    form.controls.id.setValue(data.id);
    form.controls.name.setValue(data.name);
    // form.controls.requires_doc.setValue(data.requires_doc);
    // form.controls.list_doc.setValue(data.list_doc);
    // form.controls.show_on_site.setValue(data.show_on_site);
    form.controls.value.setValue(data.value);
    // form.controls.value_defaulting.setValue(data.value_defaulting);
    form.controls.value_pix.setValue(data.value_pix);
    form.controls.lot_id.setValue(data.lot_id);
    form.controls.product_id.setValue(data.product_id);
    // form.controls.partner.setValue(data.partner);

    this.selectedSubCategoriesDataSource = new MatTableDataSource(this.currentCategoryPrice.categories)

  }

}
